import { useEffect, useState } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearControlDeliveriesAction } from "../../app/reducers/delivery-slice";
import { scheduleState } from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import Button from "../button/Button";
import { ContainedYellowButton } from "../button/ContainedYellowButton";
import { OutlinedGrayButton } from "../button/OutlinedGrayButton";
import { RouteOptimizationButton } from "../button/RouteOptimizationButton";
import { RouteOptimizationDialog } from "../dialog/RouteOptimizationDialog";
import { DraggablePreviewItemList } from "../draggable-list/DraggablePreviewItemList";
import LeftFoldIcon from "../icons/LeftFoldIcon";
import RightFoldIcon from "../icons/RightFoldIcon";
import { profileState } from "../../app/reducers/profile-slice";
import {includesPermission, Permission} from "../../utils/permission/permission";

interface Props {
  handleCreateScheduleButtonClick: () => void;
  handleUpdateScheduleButtonClick: () => void;
}

export const ScheduleCreateBoardInfo: React.FC<Props> = ({
  handleCreateScheduleButtonClick,
  handleUpdateScheduleButtonClick,
}) => {
  const { profile } = useAppSelector(profileState);
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const { preview, updateSchedule } = useAppSelector(scheduleState);

  const [openOptimizationDialog, setOpenOptimizationDialog] = useState(false);

  const openDialog = () => {
    setOpenOptimizationDialog(true);
  };

  const closeDialog = () => {
    setOpenOptimizationDialog(false);
  };

  const handleClickInitButton = () => {
    dispatch(clearControlDeliveriesAction());
  };

  useEffect(() => {
    if (preview.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [preview.length]);

  return (
    <ScheduleCreateBoardInfoContainer open={open}>
      <DashboardTableToggleButton
        onClick={() => setOpen(!open)}
        startIcon={open ? <LeftFoldIcon /> : <RightFoldIcon />}
        size="square"
      />
      {open && (
        <>
          <Header>
            <HeaderLabel>
              배송 스케줄 {updateSchedule ? "수정" : "생성"}
            </HeaderLabel>
            {!updateSchedule && (profile?.company.name === "SUPERUSER" || includesPermission(profile?.company.roles ?? [], Permission.OPTIMIZE_SCHEDULE)) && (
              <>
                <RouteOptimizationButton onClick={openDialog} />
                {openOptimizationDialog && (
                  <RouteOptimizationDialog
                      closeDialog={closeDialog}
                      taskNums={preview.length}
                  />
                )}
              </>
            )}
          </Header>

          <BodyContainer>
            <DraggablePreviewItemList />
          </BodyContainer>

          <FooterContainer>
            <OutlinedGrayButton
              width="120px"
              height="51px"
              text={"초기화"}
              onClick={handleClickInitButton}
            />
            <CreateButtonContainer>
              <ContainedYellowButton
                width="120px"
                height="51px"
                text={updateSchedule ? "수정완료" : "등록하기"}
                onClick={
                  updateSchedule
                    ? handleUpdateScheduleButtonClick
                    : handleCreateScheduleButtonClick
                }
              />
            </CreateButtonContainer>
          </FooterContainer>
        </>
      )}
    </ScheduleCreateBoardInfoContainer>
  );
};

interface ScheduleCreateBoardInfoContainerProps {
  open: boolean;
}

const ScheduleCreateBoardInfoContainer = styled.div<ScheduleCreateBoardInfoContainerProps>`
  width: ${({ open }) => (open ? "fit-content" : "0px")};
  height: 100%;
  display: flex;
  flex-direction: column;
  // position: absolute;
  z-index: 99999;
  background: ${theme.palette.primitives.white};
  // left: 497px;
  border-left: 1px solid ${theme.palette.primitives.gray200};
`;

// 스타일 체크
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  padding: 20px 24px;
  border-bottom: 1px solid ${theme.palette.primitives.gray200};
  position: relative;
`;

const HeaderLabel = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: ${theme.palette.primitives.gray800};
`;

const BodyContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 24px;
`;

const CreateButtonContainer = styled.div`
  margin-left: 0.5rem;
`;

const DashboardTableToggleButton = styled(Button)`
  position: absolute;
  top: 50px;
  right: -24px;
  margin-top: 58px;
  background: #333333;
  min-width: 24px;
  width: 24px;
  height: 72px;
  border-radius: 0px 4px 4px 0px;
  padding: 0;
  &:hover,
  &:active {
    background-color: ${theme.palette.primitives.gray700};
  }
`;
